"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var regularExpressions_1 = require("./regularExpressions");

exports.cards = {
  VISA: 'visa',
  VISA_ELECTRON: 'visaelectron',
  HIPERCARD: 'hipercard',
  MAESTRO: 'maestro',
  CABAL: 'cabal'
};
exports.cabalRulesDefinition = {
  type: exports.cards.CABAL,
  pattern: regularExpressions_1.cabalRegex,
  format: regularExpressions_1.creditCardsDefaultFormat,
  length: [16],
  cvcLength: [3],
  luhn: true
};